import * as React from 'react'
import { FC } from 'react'

export const Row: FC<{
    children: React.ReactElement | boolean | undefined | (React.ReactElement | boolean | undefined)[],
    style?: React.CSSProperties,
}> = ({children, style}) => (
    <div style={{display: 'flex', flexWrap: 'wrap', gap: 'var(--spacer-S)', ...style}}>
        {children}
    </div>
)
